// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.general.location.UpdateOfficeHoursDailyRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateOfficeHoursDailyRequest extends GandalfModelBase {

	@GandalfProperty({ designType: Date })
	closeTime!: Date | null;

	@GandalfProperty({ designType: Date })
	lunchEndTime!: Date | null;

	@GandalfProperty({ designType: Date })
	lunchStartTime!: Date | null;

	@GandalfProperty({ designType: Date })
	openTime!: Date | null;

}
